<template>
  <div class="content">
    <!-- 顶部导航栏 -->
    <div class="top-bar">
      <div class="top-bar__left">
        <div class="top-bar__logo" @click="switchCollapse">
          <img src="@/assets/logo.png" alt="" class="top-bar__logo-img">
          <span class="top-bar__logo-text">医匠设计</span>
        </div>
        <span class="top-bar__link" @click="switchMode">前往应用</span>
      </div>
      <div class="top-bar__right">
        <div v-if="hospitalInfo && hospitalInfo.name" class="top-bar__hospital">
          <el-tooltip :content="hasInsurance ? '医保服务已连接' : '医保服务未连接'" placement="bottom">
            <span :class="['top-bar__status-dot', { 'top-bar__status-dot--error': !hasInsurance }]"></span>
          </el-tooltip>
          <el-tooltip placement="bottom" effect="dark" :disabled="!hospitalTooltipContent">
            <template slot="content"><div v-html="hospitalTooltipContent"></div></template>
            <span class="top-bar__hospital-name">{{ hospitalInfo.name }}</span>
          </el-tooltip>
        </div>
        <div class="top-bar__user">
          <div class="top-bar__avatar"><i class="el-icon-user-solid"></i></div>
          <el-dropdown trigger="click" @command="handleUserCommand">
            <div class="top-bar__user-info">
              <span class="top-bar__user-name">{{ userData.name || '未知' }}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">我的资料</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="sidebar">
        <el-menu
          default-active="0"
          :collapse="isCollapse"
          class="sidebar-menu">
          <el-menu-item index="0" @click="jumpRouter('/home')">
            <i class="el-icon-s-home"></i>
            <span slot="title">主页</span>
          </el-menu-item>
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-orange"></i>
              <span>应用表单</span>
            </template>
            <el-menu-item index="1-2" @click="jumpRouter('/home/app')">
              <i class="el-icon-menu"></i><span>我的应用</span>
            </el-menu-item>
            <el-menu-item index="1-3" @click="jumpRouter('/home/datasource')">
              <i class="el-icon-link"></i><span>我的数据源</span>
            </el-menu-item>
            <el-menu-item index="1-4" @click="jumpRouter('/home/dic')">
              <i class="el-icon-notebook-1"></i><span>我的字典</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="3" @click="jumpRouter('/home/report')" v-if="isFeatureEnabled('Report')">
            <i class="el-icon-s-data"></i>
            <span slot="title">报表中心</span>
          </el-menu-item>
          <el-menu-item index="8" @click="jumpRouter('/home/work')" v-if="isFeatureEnabled('BackGroundJob')">
            <i class="el-icon-s-data"></i>
            <span slot="title">后台作业</span>
          </el-menu-item>
          <el-menu-item index="10" @click="jumpRouter('/home/rate-app')" v-if="isFeatureEnabled('RateReview')">
            <i class="el-icon-s-flag"></i>
            <span slot="title">等级评审</span>
          </el-menu-item>
          <el-menu-item index="4" @click="jumpRouter('/home/org-struct')" v-if="userData && userData.roles.includes && userData.roles.includes('admin')">
            <i class="el-icon-s-custom"></i>
            <span slot="title">组织架构</span>
          </el-menu-item>
          <el-menu-item index="4-1" @click="jumpRouter('/home/hospital-info')" v-if="isAdminModeActive">
            <i class="el-icon-first-aid-kit"></i>
            <span slot="title">医院管理</span>
          </el-menu-item>
          <el-menu-item index="4-2" @click="jumpRouter('/home/tenant-management')" v-if="isAdminModeActive">
            <i class="el-icon-office-building"></i>
            <span slot="title">租户管理</span>
          </el-menu-item>
          <el-menu-item index="4-3" @click="jumpRouter('/home/feature-management')" v-if="isAdminModeActive">
            <i class="el-icon-collection"></i>
            <span slot="title">功能管理</span>
          </el-menu-item>
          <el-menu-item index="4-4" @click="jumpRouter('/home/audit-log')" v-if="userData && userData.roles.includes && userData.roles.includes('admin')">
            <i class="el-icon-document"></i>
            <span slot="title">审计日志</span>
          </el-menu-item>
          <el-menu-item index="5" @click="jumpRouter('/home/authconfig')" v-if="userData && userData.roles.includes && userData.roles.includes('admin')">
            <i class="el-icon-s-check"></i>
            <span slot="title">角色权限</span>
          </el-menu-item>
          <el-menu-item index="5-1" @click="jumpRouter('/home/authconfig-ext')" v-if="userData && userData.roles.includes && userData.roles.includes('admin')">
            <i class="el-icon-menu"></i>
            <span slot="title">拓展管理</span>
          </el-menu-item>
          <el-menu-item index="6-1" @click="jumpRouter('/home/report-design')" v-if="userData && userData.roles.includes && userData.roles.includes('admin')">
            <i class="el-icon-edit-outline"></i>
            <span slot="title">DEV报表</span>
          </el-menu-item>
          <el-menu-item index="6-2" @click="jumpRouter('/home/report')" v-if="userData && userData.roles.includes && userData.roles.includes('admin')">
            <i class="el-icon-pie-chart"></i>
            <span slot="title">统计报表</span>
          </el-menu-item>
          <el-menu-item index="6-3" @click="jumpRouter('/home/setting')" v-if="userData && userData.roles.includes && userData.roles.includes('admin')">
            <i class="el-icon-setting"></i>
            <span slot="title">系统设置</span>
          </el-menu-item>
        </el-menu>
        <div v-if="!isCollapse" class="sidebar-footer">
          <span>版本 v1.0.022</span>
        </div>
      </div>
      <div class="main">
        <router-view />
      </div>
    </div>
    <el-dialog  
        title="用户资料"
        width="600px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="userInfoVisible">
        <div>
            <user-info  />
        </div>
    </el-dialog>  
  </div>
</template>

<script> 
import UserInfo from '@/components/users/UserInfo.vue';
import { clearCache, getLocalUser } from '@/services/user.service';
import { isAdminMode } from '@/utils/tenant';
import { getFeautureList } from '@/utils/config';
import { getHospital } from '@/services/inst.service';
import { formatDate } from '@/filters/dateformat';
export default {
  name: 'HomeView',
  components: {
    UserInfo
  },
  data() {
      return {
        sysInfoModel: {
          name: ''
        },
        hospitalInfo: null,
        userData: {
          name: '',
          phone: '',
          email: '',
          roles: []
        },
        userInfoVisible: false,
        isCollapse: false,
        featureValues: {}
      };
    },
    mounted(){
      this.userData = getLocalUser();
      this.loadFeatureFlags(); 
      // 从缓存获取医院信息
      const hospital = getHospital();
      if (hospital) {
          this.hospitalInfo = hospital; 
      }
    },
    computed: {
      isAdminModeActive() {
        return isAdminMode();
      },
      hasInsurance() {
        if (!this.hospitalInfo) return false;
        return !!(this.hospitalInfo.hisLocalServiceUrl);
      },
      hospitalTooltipContent() {
        if (!this.hospitalInfo) {
          return '';
        }
        const info = this.hospitalInfo;
        const lines = [];
        
        if (info.admvs || info.Admvs || info.Admdvs) {
          lines.push(`医保区号: ${info.admvs || info.Admvs || info.Admdvs }`);
        } else {
          lines.push(`医保区号: 无医保模式`);
        }
        if (info.code || info.Code) {
          lines.push(`医院编码: ${info.code || info.Code}`);
        } 
        if (info.level || info.Level || info.instLevel || info.InstLevel) {
          lines.push(`等级: ${info.level || info.Level || info.instLevel || info.InstLevel || '无'}`);
        }
        if (info.region || info.Region) {
          lines.push(`区域: ${info.region || info.Region}`);
        }
        if (info.registerTime || info.RegisterTime) {
          const registerTime = info.registerTime || info.RegisterTime;
          const formattedTime = formatDate(registerTime, 'yyyy-MM-dd');
          lines.push(`注册时间: ${formattedTime}`);
        }
        return lines.length > 0 ? lines.join('<br/>') : '';
      }
    },
    methods: {
      showUserInfo(){
        this.userInfoVisible = true;
      },
      jumpApp(){
        this.$router.push('/index/app');
      },
      switchMode(){
        this.getAppMenu();
      },
      loadFeatureFlags() {
        const featureValues = getFeautureList() || {};
        this.featureValues = featureValues;
      },
      isFeatureEnabled(key) {
        const value = this.featureValues ? this.featureValues[key] : null;
        if (typeof value === 'boolean') {
          return value;
        }
        if (typeof value === 'string') {
          return value.toLowerCase() === 'true';
        }
        return false;
      },
      // 获取当前角色，有权限访问的应用菜单列表
      getAppMenu(){
        this.$router.push('/index');
      },
      handleUserCommand(command) {
        if (command === 'profile') this.showUserInfo();
        else if (command === 'logout') this.logout();
      },
      switchCollapse(){
        this.isCollapse = !this.isCollapse;
      },
      logout(){
        clearCache();
        this.$router.push('/login');
      },
      jumpRouter(router){
        this.$router.push(router);
      }
    }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f5f7fa;
}

/* ========== 顶部导航栏 ========== */
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 20px;
  background: #fff;
  border-bottom: 1px solid #e8ecf0;
  flex-shrink: 0;
}
.top-bar__left {
  display: flex;
  align-items: center;
  gap: 20px;
}
.top-bar__logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
}
.top-bar__logo-img {
  width: 34px;
  height: 34px;
}
.top-bar__logo-text {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  white-space: nowrap;
}
.top-bar__link {
  color: #409EFF;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  &:hover { opacity: 0.8; }
}
.top-bar__right {
  display: flex;
  align-items: center;
  gap: 20px;
}
.top-bar__hospital {
  display: flex;
  align-items: center;
  gap: 8px;
}
.top-bar__status-dot {
  width: 8px;
  height: 8px;
  background: #67c23a;
  border-radius: 50%;
  flex-shrink: 0;
  cursor: pointer;
  &--error { background: #f56c6c; }
}
.top-bar__hospital-name {
  font-size: 14px;
  color: #303133;
  cursor: pointer;
  white-space: nowrap;
}
.top-bar__user {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.top-bar__avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #e8ecf0;
  display: flex;
  align-items: center;
  justify-content: center;
  i { font-size: 18px; color: #909399; }
}
.top-bar__user-info {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}
.top-bar__user-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}
/* 下拉箭头垂直居中 */
.top-bar__user ::v-deep .el-dropdown {
  display: flex;
  align-items: center;
}
.top-bar__user ::v-deep .el-icon--right {
  margin-top: 0;
}

/* ========== 主体区域 ========== */
.body {
  flex: 1;
  display: flex;
  overflow: hidden;
}

/* ========== 左侧菜单栏 ========== */
.sidebar {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-right: 1px solid #e8ecf0;
  overflow: hidden;
}
.sidebar-menu {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: none !important;
  &:not(.el-menu--collapse) {
    width: 240px;
  }
}
.sidebar-menu ::v-deep .el-submenu__title {
  display: flex;
  align-items: center;
  height: 48px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  .el-submenu__icon-arrow { margin-top: 0; }
}
.sidebar-menu ::v-deep .el-menu-item {
  height: 42px;
  line-height: 42px;
  font-size: 13px;
  color: #606266;
  &.is-active {
    color: #409EFF;
    font-weight: 500;
    background: #ecf5ff;
  }
}
.sidebar-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  font-size: 12px;
  color: #c0c4cc;
  border-top: 1px solid #e8ecf0;
  flex-shrink: 0;
}

/* ========== 主内容区 ========== */
.main {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f5f7fa;
}
</style>
